export const NO_CUSTOMER_ACCESS_ERROR_MESSAGE =
  "No Customer access available. Please contact your administrator or try again later.";

export const SESSION_ME_LOAD_ERROR_MESSAGE =
  "Unable to fetch User Access Details, please try after some time";

export const SESSION_ACCOUNT_SUSPENDED_MESSAGE =
  "Your account has been suspended. Please contact your administrator.";

export const SESSION_CUSTOMER_ACCESS_LOAD_ERROR_MESSAGE =
  "Unable to load customer access. Please try again later.";

export const SESSION_ACTIVE_CUSTOMER_ACCESS_REVOKED_MESSAGE =
  "Your last active customer access has been revoked. Please contact your administrator or switch to another customer.";

export const SESSION_ACTIVE_CUSTOMER_ACCESS_REVOKED_TITLE =
  "Customer access revoked";

export const SESSION_ACTIVE_CUSTOMER_UNAVAILABLE_TITLE =
  "Customer is unavailable";

export const buildActiveCustomerAccessRevokedMessage = (customerName) => {
  const name = String(customerName ?? "").trim();
  if (!name) {
    return SESSION_ACTIVE_CUSTOMER_ACCESS_REVOKED_MESSAGE;
  }
  return `Your access to ${name} has been revoked. Please contact your administrator or switch to another customer.`;
};

export const SESSION_ACTIVE_CUSTOMER_UNAVAILABLE_MESSAGE =
  "Your customer is no longer available. Please contact Administrator or switch to another customer.";

export const buildActiveCustomerUnavailableMessage = (customerName) => {
  const name = String(customerName ?? "").trim();
  if (!name) {
    return SESSION_ACTIVE_CUSTOMER_UNAVAILABLE_MESSAGE;
  }
  return `Your customer ${name} is no longer available. Please contact Administrator or switch to another customer.`;
};
